var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPasswordCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5912 8.5C14.5912 10.2239 13.9064 11.8772 12.6874 13.0962C11.4684 14.3152 9.81509 15 8.09119 15C6.36728 15 4.71398 14.3152 3.49499 13.0962C2.27601 11.8772 1.59119 10.2239 1.59119 8.5C1.59119 6.77609 2.27601 5.12279 3.49499 3.90381C4.71398 2.68482 6.36728 2 8.09119 2C9.81509 2 11.4684 2.68482 12.6874 3.90381C13.9064 5.12279 14.5912 6.77609 14.5912 8.5ZM16.0912 8.5C16.0912 10.6217 15.2483 12.6566 13.748 14.1569C12.2478 15.6571 10.2129 16.5 8.09119 16.5C5.96945 16.5 3.93462 15.6571 2.43433 14.1569C0.934041 12.6566 0.0911865 10.6217 0.0911865 8.5C0.0911865 6.37827 0.934041 4.34344 2.43433 2.84315C3.93462 1.34285 5.96945 0.5 8.09119 0.5C10.2129 0.5 12.2478 1.34285 13.748 2.84315C15.2483 4.34344 16.0912 6.37827 16.0912 8.5ZM11.8712 6.78C12.0037 6.63783 12.0758 6.44978 12.0724 6.25548C12.0689 6.06118 11.9902 5.87579 11.8528 5.73838C11.7154 5.60097 11.53 5.52225 11.3357 5.51883C11.1414 5.5154 10.9534 5.58752 10.8112 5.72L6.84119 9.69L5.62119 8.47C5.47901 8.33752 5.29097 8.2654 5.09666 8.26883C4.90236 8.27225 4.71698 8.35097 4.57956 8.48838C4.44215 8.62579 4.36344 8.81118 4.36001 9.00548C4.35658 9.19978 4.42871 9.38783 4.56119 9.53L6.31119 11.28C6.45181 11.4205 6.64244 11.4993 6.84119 11.4993C7.03994 11.4993 7.23056 11.4205 7.37119 11.28L11.8712 6.78Z",
    fill: "#09C215"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordCheck);
export default __webpack_public_path__ + "static/media/password-check.4dafb5e914a6a3dcb25a14a30f2fa000.svg";
export { ForwardRef as ReactComponent };